export default __webpack_public_path__ + "static/header_sponsor_1-6b5d6525e8ecd938dfb9af98c248462a.svg";